import gql from "graphql-tag";

export default {
update: gql`
    mutation UpdatePhotoboothStripePrintCell ($input: UpdatePhotoboothStripePrintCellInput!) {
        updatePhotoboothStripePrintCell (input: $input) {
            id
            email
            qr_code
            print
            text_color
            border_color
            filter_uri
            photo_count
        }
    }`,

get: gql`
    query PhotoboothStripePrintCell($id: ID!) {
        photoboothStripePrintCell(id: $id) {
            id
            email
            qr_code
            print
            text_color
            border_color
            filter_uri
            photo_count
        }
    }`
}
